import React from 'react';
import { useOktaAuth } from '@okta/okta-react';

const Login: React.FC = () => {
  const { oktaAuth } = useOktaAuth();

  const handleLogin = () => {
    oktaAuth.signInWithRedirect();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cargo-accent to-blue-700 flex items-center justify-center">
      <div className="bg-cargo-surface border border-cargo-border rounded-xl p-10 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 bg-cargo-accent rounded-xl flex items-center justify-center">
            {/* Brand-mark icon only (no wordmark) — the "Elevatenow"
                wordmark would duplicate the heading below. EN.png is
                the gray favicon mark; CSS-invert it to white so it sits
                clean on the blue badge, matching the sidebar. */}
            <img
              src="/EN.png"
              alt="Elevatenow"
              className="w-9 h-9 object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-cargo-text mb-2">Elevatenow DQ</h1>
        <p className="text-cargo-muted mb-8">
          Sign in to access your data quality workspace
        </p>
        <button
          onClick={handleLogin}
          className="w-full bg-cargo-accent hover:bg-cargo-accent-hover text-white font-semibold
                     py-3 px-6 rounded-lg transition-colors duration-200"
        >
          Sign in with Okta
        </button>
      </div>
    </div>
  );
};

export default Login;
